<template>
    <div>
        <div>
        <slot>
            <ui-button  
                id="consumableSelector"
                ref="trigger"
                :disabled="disabled"
                icon="opacity" 
                style="width: 100%; margin-bottom: .5rem; justify-content: left;"
            >Consumables</ui-button>
        </slot>
        </div>
        <ui-popover ref="popover" trigger="#consumableSelector" v-show="!disabled" @open="onOpen" class="consumable-selector">
            <div style="width:100%; background:#f8f8f8; padding: .8rem 1rem;">Consumables</div>
            <div style="padding: 1rem 1rem 0; width: 500px;">
                <div v-if="isLoading" class="text-center"><cog-loader></cog-loader></div>
                <div v-else style="padding-bottom: .25rem">
                    <div style="max-height: 308px; overflow-y: auto; ">
                        <table class="table">
                            <tbody v-if="consumables.length > 0">
                                <tr v-for="item in consumables">
                                    <td>
                                        <ui-checkbox v-model="item.selected"></ui-checkbox>
                                    </td>
                                    <td>
                                        <div>{{ item.name }}</div>
                                    </td>
                                    <td class="text-center">
                                        <ui-icon-button 
                                            style="vertical-align: middle;" 
                                            icon="remove" 
                                            size="small" 
                                            @click="decrement(item)"
                                        ></ui-icon-button>
                                        <ui-textbox 
                                            v-model="item.quantity_selected"    
                                            class="qty-text-box"
                                        ></ui-textbox>
                                        <ui-icon-button 
                                            style="vertical-align: middle;" 
                                            icon="add" 
                                            size="small" 
                                            @click="increment(item)"
                                        ></ui-icon-button>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="3">No consumables available</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row mb-2 mt-2">
                        <div class="col">
                            <ui-button :disabled="0 === selected.length" @click="attach" color="primary">Attach</ui-button>
                        </div>
                        <div class="col text-right">
                            <!-- !-->
                        </div>
                    </div>
                </div>
            </div>
        </ui-popover>

        <expense-modal ref="expenseModal" @close="show"></expense-modal>
    </div>
</template>

<style lang="scss">
    .consumable-selector {
        .qty-text-box {
            width: 35px; 
            display: inline-block; 
            margin-bottom: 0;

            input { text-align: center; }
        }
    }
</style>

<script>
    import ExpenseModal from '../ExpenseModal'
    import { ConsumableResource } from '../../../classes/Api/Consumable'

    export default {
        components: {
            ExpenseModal,
        },
        props: {
            task: {},
            disabled: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            id: {
                default() {
                    return Math.random();
                }
            }
        },
        mounted() {
            if (this.expense) {
                this.selected = this.expense;
            }
        },
        watch: {
            expense: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.selected = (newVal === null ? {} : newVal);
                    }
                },
                deep: true,
            },
        },
        data() {
            return {
                consumables: [],
                isLoading: true,
            }
        },
        computed: {
            selected() {
                return this.consumables.filter(item => {
                    return true === item.selected
                })
            }
        },
        methods: {
            add() {
                this.$refs.expenseModal.open()
                this.reset();
            },
            attach() {
                this.reset();
                for (let i in this.selected) {
                    this.$emit('attach', this.selected[i])
                }
            },
            increment(item) {
                item.quantity_selected += 0.25
            },
            decrement(item) {
                if (item.quantity_selected > 0.25) {
                    item.quantity_selected -= 0.25
                }
            },
            save() {
                this.$emit('save', Object.assign({}, this.selected));
            },
            destroy() {
                this.$emit('save', null, null);
            },
            reset() {
                this.$refs['popover'].close();
            },
            show() {
                this.$refs.popover.open()
            },
            onOpen() {
                this.isLoading = true;
                
                ConsumableResource.all({ for_task: this.task.id }).then(response => {
                    this.consumables = response.data.map(item => {
                        item.quantity_selected = 1
                        item.selected = false
                        return item
                    });
                    this.isLoading = false
                });
            }
        }
    }
</script>